import React from "react";

import {useTranslation} from "react-i18next";

import InputWithButton from "./inputwithbutton";
import Button from "./button";


type props = Omit<React.ComponentProps<typeof InputWithButton>, "button"> & {
  buttonClassName?: React.ComponentProps<typeof Button>["className"];
  onButtonClick?: React.ComponentProps<typeof Button>["onClick"];
};

export default function InputWithReset({buttonClassName, onButtonClick, ...props}: props) {
  const {t} = useTranslation();

  return (
    <InputWithButton
      button={
        <Button className={buttonClassName} color="danger" onClick={onButtonClick}>
          {t("common.reset")}
        </Button>
      }
      {...props}
    />
  );
}
